import { ComponentProps } from "."
import {
  CharactersCount,
  ErrorText,
  InfoText,
  Label,
  SuccessText,
  TextAreaInput,
  TextAreaWrapper
} from "./styled"

const DEFAULT_COLS = 50
const DEFAULT_ROWS = 10

const TextArea = ({
  charactersCountLabel,
  className,
  cols = DEFAULT_COLS,
  defaultValue,
  disabled,
  error,
  errorText,
  infoText,
  inputId,
  isExpanded,
  isMaxCharactersExceeded,
  label,
  labelId,
  name,
  onBlur,
  onChange,
  placeholder,
  ref,
  required,
  rows = DEFAULT_ROWS,
  success,
  successText,
  value
}: ComponentProps) => (
  <TextAreaWrapper
    $error={error}
    $hasCharactersCount={Boolean(charactersCountLabel)}
    $isExpanded={isExpanded}
    $success={success}
    className={className}
  >
    <TextAreaInput
      aria-labelledby={labelId}
      cols={cols}
      defaultValue={defaultValue}
      disabled={disabled}
      id={inputId}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      ref={ref}
      required={required}
      rows={rows}
      value={value}
    />

    {label ? (
      <Label htmlFor={inputId} id={labelId}>
        {label}
      </Label>
    ) : null}

    {charactersCountLabel ? (
      <CharactersCount
        $isMaxCharactersExceeded={isMaxCharactersExceeded}
        aria-live="polite"
      >
        {charactersCountLabel}
      </CharactersCount>
    ) : null}

    {errorText ? <ErrorText role="alert">{errorText}</ErrorText> : null}

    {infoText ? <InfoText aria-live="polite">{infoText}</InfoText> : null}

    {successText ? (
      <SuccessText aria-live="polite">{successText}</SuccessText>
    ) : null}
  </TextAreaWrapper>
)

TextArea.displayName = "TextArea"

export default TextArea
